import * as yup from "yup";
import {
  DATE_FORMATS,
  VALIDATION_REGEX,
  VEHICLE_TAGS,
  VehicleTagType,
} from "utils/constants";
import i18next from "config/i18next";
const requiredMessage = i18next.t("validations:required");

const requiredString = yup.string().required(requiredMessage);
const optionalString = yup.string().optional();
const isValidDate = yup
  .string()
  .nullable()
  .matches(DATE_FORMATS.regex, i18next.t("validations:enterValidFormat"))
  .matches(
    DATE_FORMATS.regexValidCharacter,
    i18next.t("validations:enterValidFormat")
  );

const motorcycleSchema = (approve: boolean) =>
  yup
    .string()
    .concat(approve ? requiredString : optionalString)
    .matches(
      VALIDATION_REGEX.regPatentCO,
      i18next.t("vehicle:patentFormatError")
    );

const wheels4Schema = (approve: boolean) =>
  yup
    .string()
    .concat(approve ? requiredString : optionalString)
    .min(6, i18next.t("vehicle:wheels4PatentLongError"));

export const vehicleSchemaCO = (approve: boolean, vehicle: VehicleTagType) =>
  yup.object({
    patent:
      vehicle === VEHICLE_TAGS.MOTORCYCLE
        ? motorcycleSchema(approve)
        : wheels4Schema(approve),
    expirationDatePolicyVehicle: yup
      .string()
      .concat(approve ? requiredString : optionalString)
      .concat(isValidDate),
    expirationDateIdentificationVehicle: yup
      .string()
      .concat(approve ? requiredString : optionalString)
      .concat(isValidDate),
    expirationDateDriverLicense: yup
      .string()
      .concat(approve ? requiredString : optionalString)
      .concat(isValidDate),
  });
